<template>
  <div class="common-font-size">

    <!-- 工厂管理员工厂信息界面 -->
    <div class="white-background list-top-margin" v-if="user && user.role != '超级管理员'">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统配置</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">工厂</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="user-search sys-title">系统信息</div>
      <div class="system-box">
        <!--<div class="title list-top-margin">-->
          <!--<div>{{system.factoryName}}</div>-->
          <!--<div class="system-divider"></div>-->
          <!--<div class="remaining">-->
            <!--<span>剩余</span>-->
            <!--<span class="days">{{system.surplus}}</span>-->
            <!--<span>天</span>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="list-top-margin">-->
          <!--<el-button type="success" plain size="small" @click="clearSystem">清空系统数据</el-button>-->
        <!--</div>-->
        <div class="field-item">
          <i class="el-icon-box"></i>
          <span class="left">工厂编号</span>
          <div>{{system._id}}</div>
        </div>
        <div class="field-item">
          <i class="el-icon-postcard"></i>
          <span class="left">工厂名称</span>
          <div v-if="!isFlag">{{system.factoryName}}</div>
          <el-input v-model="name" placeholder="请输入" size="small" style="width: 250px;" v-if="isFlag"></el-input>
          <i class="el-icon-edit-outline left-large-margin cursor-pointer" @click="uptClick" v-if="!isFlag" style="color:#1890ff;font-size:18px;"></i>
          <i class="el-icon-circle-close left-large-margin cursor-pointer" @click="uptClick" v-if="isFlag" style="color:red;font-size:18px;"></i>
          <i class="el-icon-circle-check left-large-margin cursor-pointer" @click="confimClick" v-if="isFlag" style="color:green;font-size:18px;"></i>
        </div>
        <div class="field-item">
          <i class="el-icon-time"></i>
          <span class="left">截止日期</span>
          <div>{{system.exp}}</div>
        </div>
        <!--<div class="field-item">-->
          <!--<i class="el-icon-cloudy"></i>-->
          <!--<span class="left">云环境</span>-->
          <!--<div>默认</div>-->
        <!--</div>-->
        <!--<div class="field-item">-->
          <!--<i class="el-icon-shopping-bag-2"></i>-->
          <!--<span class="left">产品</span>-->
          <!--<div>智慧工厂</div>-->
        <!--</div>-->
      </div>
    </div>

    <!-- 超级管理员工厂管理界面 -->
    <div v-if="user && user.role == '超级管理员'">
        <div class="white-background list-top-margin">
          <!-- 面包屑导航 -->
          <div class="page-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>系统配置</el-breadcrumb-item>
              <el-breadcrumb-item>
                <span style="color:#000;font-weight:bold;">工厂</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 搜索筛选 -->
          <el-form :model="form" class="user-search" label-width="110px" size="small">
            <el-row>
              <el-col :span="5">
                <el-form-item label="工厂名称">
                  <el-input size="small" v-model="form.condition.factoryName" placeholder="请输入工厂名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="用户数">
                  <!-- <el-input-number v-model="form.condition.userNum"   controls-position="right" size="medium" ></el-input-number> -->
                  <el-input v-model="form.condition.userNum"  placeholder="请输入用户数"   size="small" ></el-input>

                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="是否已审批">
                  <el-select
                    v-model="form.condition.approval"
                    placeholder="请选择"
                    style="width:100%;"
                    clearable
                  >
                    <el-option
                      v-for="item in approvalList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="是否已删除">
                  <el-select
                    v-model="form.condition.isDelete"
                    placeholder="请选择"
                    style="width:100%;"
                    clearable
                  >
                    <el-option
                      v-for="item in deleteList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>



              <el-col :span="3" class="text-align-right">
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="white-background">
            <el-row class="tbl-btn list-top-margin">
              <el-col :span="12" class="tbl-btn-left">
                <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="createFactory">创建工厂</el-button> -->
                <!-- <el-dropdown class="left-default-margin right-default-margin" @command="batchDel" trigger="click" >
                  <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->


                <!-- <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
                <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button> -->
                <!-- <el-button size="small" type="danger" plain icon="el-icon-delete" :disabled="delDisabled" @click="batchDel">批量删除</el-button> -->
                <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
                  <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <!-- <el-col :span="12" class="tbl-btn-right">
                <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
              </el-col> -->
            </el-row>
            <!--列表-->
            <el-table
              ref="tableData"
              size="small"
              :data="listData"
              highlight-current-row
              v-loading="loading"
              stripe
              :header-cell-style="_headerStyle"
              border
              element-loading-text="加载中"
              style="width: 100%;"
              @selection-change="handleTblSelectionChange"
              row-key="_id"
            >
              <el-table-column align="left" type="selection" width="60" :reserve-selection="true"></el-table-column>
              <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
              <el-table-column label="工厂名称">
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.factoryName" placement="top">
                    <span class="txt-overflow">{{scope.row.factoryName}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="userNum" label="用户数" width="110"></el-table-column>
              <el-table-column prop="approval" label="是否已审批" width="110">
                <template slot-scope="scope">
                    <span class="txt-overflow">{{scope.row.approval?'是':'否'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="isDelete" label="是否删除" width="100">
                <template slot-scope="scope">
                    <span class="txt-overflow">{{scope.row.isDelete?'是':'否'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="exp" label="到期时间"></el-table-column>
              <el-table-column prop="phoneNum" label="联系电话"></el-table-column>
              <el-table-column prop="contacts" label="联系人"></el-table-column>

              <el-table-column align="left" label="操作" width="210" fixed="right">
                <template slot-scope="scope">
                    <el-tooltip content="编辑">
                      <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        circle
                        @click="handleEdit(scope.$index, scope.row)"
                      ></el-button>
                    </el-tooltip>


                    <el-tooltip content="删除">
                      <el-popconfirm title="确认删除？" @confirm="handleDelete(scope.$index, scope.row)">
                          <el-button
                              size="mini"
                              type="danger"
                              icon="el-icon-delete"
                              circle
                              slot="reference"
                          ></el-button>
                      </el-popconfirm>

                    </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
        </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="600px" @close="done" :close-on-click-modal="false">
      <create-dialog v-if="dialogVisible" @done="done"></create-dialog>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="factoryVisible" width="600px" @close="factoryClose" :close-on-click-modal="false">
      <factoryModal v-if="factoryVisible"  :rowData="rowData"  @save="factorySave" @close="factoryClose"></factoryModal>

    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import { uptFactory,queryFactoryList,delFactoryBatch,delFactoryById,queryFactoryById,uptFactoryNew} from '@/api/business';
import CreateDialog from "./create-dialog";
import factoryModal from "@/views/systemSetting/factorySys/factoryModal";
import Pagination from "@/components/Pagination";
export default {
  components:{
    CreateDialog,
    Pagination,
    factoryModal
  },
  data() {
    return {
      system:{
        name:'云管家小工单演示环境',
        surplus:'37'
      },
      dialogVisible:false,
      isFlag:false,
      name:'',


      // 超级管理员
      listData:[],
      form:{
        "condition": {
          "factoryName":null,
          "approval": null,
          // "factoryId": "",
          "userNum": null,
          "isDelete": null,
        },
        "currentPage": 1,
        "pageSize": 10
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tblSelectionList:[],
      loading:false,
      title:'创建工厂',
      factoryVisible:false,
      rowData:{},
      delDisabled:true,
      approvalList:[

        {
          label:'是',
          value:true,
        },
        {
          label:'否',
          value:false,
        },
      ],
      deleteList:[

        {
          label:'是',
          value:true,
        },
        {
          label:'否',
          value:false,
        },
      ],
      user:JSON.parse(window.localStorage.getItem('userdata')),
      para : {

        "currentPage": 1,
        "pageSize": 10
      },

    }
  },
  created() {
    if(this.user['role'] == '超级管理员'){
      // this.form.condition.factoryId = this.user.factoryId;
      this.getList();
    }else{
      this.init();
    }
  },
  methods: {
    init(){
      queryFactoryById(this.user['factoryId']).then(res=>{
        if(res['code'] == 200){

          this.system = res['data'];

        }
      })
    },
    getList(){
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.form));
      // if(!data.condition.approval || data.condition.approval == null){
      //   delete data.condition.approval;
      // }
      // if(!data.condition.isDelete || data.condition.isDelete == null){
      //   delete data.condition.isDelete;
      // }
      if(!isNaN(data.condition.userNum)){
         data.condition.userNum = parseInt(data.condition.userNum);
      }
      queryFactoryList(data).then(res=>{
        this.loading = false;
        if(res['code'] == 200){
          this.listData = res['data']['list'];
          this.pageparm = res["data"];
        }
      })
    },
    search() {
        this.form['currentPage'] = 1;
        this.form['pageSize'] = 10;
        this.getList();
    },
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
      if(this.tblSelectionList.length == 0){
        this.delDisabled = true;
      }else{
        this.delDisabled = false;
      }
    },
    callFather(param) {
      this.form['currentPage'] = param['currentPage'];
      this.form['pageSize'] = param['pageSize'];
      this.getList();
    },

    handleEdit(index,row){

      queryFactoryById(row['_id']).then(res=>{
        if(res['code'] == 200){

          this.title = "编辑工厂";
          this.rowData = res['data'];
          this.factoryVisible = true;

        }
      })


    },
    handleDelete(index,row){
      delFactoryById(row['_id']).then(res=>{
        if(res['code'] == 200){
              if(res['code'] == 200){
                this.$message({
                  type: 'success',
                  message: '操作成功！'
                });

              }else{
                this.$message.error(res['msg'] || '操作失败！');
              }
              this.getList();
        }
      })
    },
    createFactory(){
    },
    factorySave(val){


      uptFactory(val).then(res=>{
        if(res['code'] == 200){
          this.$message({
            type: 'success',
            message: '操作成功！'
          });

        }else{
          this.$message.error(res['msg'] || '操作失败！');
        }
        this.getList();
        this.factoryVisible = false;
      })

    },
    factoryClose(){
      this.factoryVisible = false;
    },

    batchDel(){

    },


    clearSystem(){
      this.dialogVisible = true
    },
    done(){
      this.dialogVisible = false
    },
    uptClick(){
      this.name = this.system.factoryName;
      this.isFlag = !this.isFlag;
    },
    confimClick(){
      let param = Object.assign({},this.system);
      param['factoryName'] = this.name;
      param['_id'] =  this.system._id;
      //param['approval'] = this.system['approval']?true:false;
      uptFactoryNew(param).then(res=>{
        if(res['code'] == 200){
          this.$message({
            type: 'success',
            message: '操作成功！'
          });


        }else{
          this.$message.error(res['msg'] || '操作失败！');
        }
        this.init();
        this.isFlag = !this.isFlag;
      })
    },
     // 批量操作
     handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})

          delFactoryBatch(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  },
}
</script>
<style scoped>
.system-box{
  margin-bottom: 32px;
  padding: 24px;
  background: #fff;
}
.system-box .title{
  display: flex;
  align-items: center;
  width: 100%;
  color: #111;
  font-weight: 600;
  font-size: 16px;
  font-family: PingFangSC-Semibold,PingFang SC;
}
.system-box .system-divider{
  width: 1px;
  height: 16px;
  margin: 0 16px;
  background-color: #e5e5e5;
}
.system-box .remaining{
  color: #303133;
  font-weight: 400;
}
.system-box .days{
    margin: 0 2px;
    color: #02b980;
}
.sys-title{
  color: #111;
  font-size: 16px;
  font-family: PingFangSC-Semibold,PingFang SC;
}
.field-item{
    display: flex;
    align-items: center;
    height: 28px;
    margin-bottom: 16px;
    color: #333;
    color: #111;
    font-weight: 400;
    font-size: 14px;
    font-family: PingFangSC-Regular,PingFang SC;
}
.field-item .left{
  width: 56px;
  margin-right: 24px;
  margin-left: 6px;
  line-height: 14px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/views/systemSetting/factorySys/factorySys.vue